import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Centralized currency formatting function for INR
export function formatCurrency(amount: number | undefined | null): string {
  // Handle undefined, null, or NaN values
  if (amount === undefined || amount === null || isNaN(amount)) {
    return '₹0.00';
  }
  
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(amount);
}

// Remove trailing zeroes from decimal numbers
export function removeTrailingZeroes(number: number): string {
  return parseFloat(number.toFixed(10)).toString();
}

// Format rating with trailing zeroes removed
export function formatRating(rating: number): string {
  return removeTrailingZeroes(rating);
}
